import { Font, StyleSheet } from '@react-pdf/renderer';
import { colors } from 'src/constants';

// NOTE: Check https://react-pdf.org/fonts for more built in fonts.
const mainFont = 'Courier';
const mainFontBold = `${mainFont}-Bold`;

// Font.register({ family: 'Playfair Display', src: './PlayfairDisplay-Bold.ttf', fontWeight: 'bold' });
Font.register({
  family: 'Playfair Display',
  src: '/static/fonts/playfairDisplay/PlayfairDisplay-Bold.ttf',
  fontWeight: 'bold'
});
// Font.register({ family: 'Playfair Display', src: './PlayfairDisplay-Bold.ttf', fontWeight: 'bold' });
Font.register({
  family: 'OpenSans',
  fonts: [
    { src: '/static/fonts/openSans/OpenSans-Regular.ttf' }, // font-style: normal, font-weight: normal
    {
      src: '/static/fonts/openSans/OpenSans-SemiBold.ttf',
      fontStyle: 'semi-bold',
      fontWeight: 600
    },
    {
      src: '/static/fonts/openSans/OpenSans-Bold.ttf',
      fontStyle: 'bold',
      fontWeight: 700
    }
  ]
});

export const warrantyTextStyles = StyleSheet.create({
  /** ========== START OF QUOTATION SCREENSHOT PDF TEXT STYLES ========== */
  openSansRegular: {
    fontSize: 7.4,
    fontFamily: 'OpenSans'
  },
  openSansSemiBold: {
    fontSize: 7.4,
    fontFamily: 'OpenSans',
    fontStyle: 'semi-bold'
  },
  openSansBold: {
    fontSize: 7.4,
    fontFamily: 'OpenSans',
    fontStyle: 'bold'
  },
  /** ========== END OF QUOTATION SCREENSHOT PDF TEXT STYLES ========== */

  text: {
    fontSize: 8,
    fontFamily: mainFontBold
  },
  textBold: {
    fontSize: 8,
    fontFamily: mainFontBold
  },
  playFairBold: {
    fontFamily: 'Playfair Display',
    fontSize: 8
  },
  url: {
    fontSize: 8,
    textDecoration: 'underline',
    color: colors.blue[600]
  },
  underline: {
    textDecoration: 'underline'
  }
});
